import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconDashboard } from "@tabler/icons-react";
import { DashboardPersonalFiltersDef } from "./DashboardPersonalFiltersDef";

export const DashboardIcon = IconDashboard;
export const DashboardHelpText = '* Dashboard.';

export class DashboardPersonalFilters extends Entity<DashboardPersonalFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new DashboardPersonalFiltersDef(), parentKeys);
        this.Form = import('./DashboardPersonalFiltersForm').then((module) => module.DashboardPersonalFiltersForm);
        this.Title = "Dashboard";
        this.HelpText = DashboardHelpText;
        this.Icon = DashboardIcon;
    }
}